// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/secrets.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from message protogen.SecretStub
 */
export class SecretStub extends Message<SecretStub> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string valueType = 3;
   */
  valueType = "";

  /**
   * @generated from field: int64 creationTimeSec = 4;
   */
  creationTimeSec = protoInt64.zero;

  /**
   * @generated from field: string creatorRef = 5;
   */
  creatorRef = "";

  constructor(data?: PartialMessage<SecretStub>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SecretStub";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "valueType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "creationTimeSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "creatorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SecretStub {
    return new SecretStub().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SecretStub {
    return new SecretStub().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SecretStub {
    return new SecretStub().fromJsonString(jsonString, options);
  }

  static equals(a: SecretStub | PlainMessage<SecretStub> | undefined, b: SecretStub | PlainMessage<SecretStub> | undefined): boolean {
    return proto3.util.equals(SecretStub, a, b);
  }
}

